import type { ComponentType } from 'react';
import type { FC } from 'react';

export interface PromotionCarouselAdProps {
  Swiper: ComponentType<any>;
  SwiperSlide: ComponentType<any>;
  modules?: any[];
  autoplay?: any;
  loop?: boolean;
  slidesPerView?: any;
  watchSlidesProgress?: boolean;
  className?: string;
  slideClassName?: string;

  href: string;
  onClick?: () => void;
  imageUrls: string[];
  imgClassName?: string;
  imgAlt?: string;
  target?: string;
  rel?: string;
}

export const PromotionCarouselAd: FC<PromotionCarouselAdProps> = (props) => {
  const {
    Swiper,
    SwiperSlide,
    modules,
    autoplay,
    loop = true,
    slidesPerView = 'auto',
    watchSlidesProgress = true,
    className,
    slideClassName = 'flex items-center justify-center transform-gpu',
    href,
    onClick,
    imageUrls,
    imgClassName = 'inline w-full rounded-[10px]',
    imgAlt,
    target,
    rel,
  } = props;

  return (
    <Swiper
      loop={loop}
      autoplay={autoplay}
      slidesPerView={slidesPerView}
      watchSlidesProgress={watchSlidesProgress}
      modules={modules}
      className={className}
    >
      {imageUrls.map((src, index) => (
        <SwiperSlide key={src || index} className={slideClassName}>
          <a href={href} target={target} rel={rel} onClick={onClick}>
            <img className={imgClassName} src={src} alt={imgAlt || href} />
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
